import { type GetServerSideProps } from 'next';

import { type SitemapPageProps } from '../../../modules/sitemap/@interfaces';
import { getSitemapData } from '../../../modules/sitemap';

import { withEnhancedPageHandler } from '../../../middlewares/withEnhancedPageHandler';

import { SitemapTemplate } from '../../../templates';

const SitemapBySlug = (props: SitemapPageProps) => (
  <SitemapTemplate {...props} />
);

const getServerSidePropsHandler: GetServerSideProps = async ({ query }) => {
  const slug = query.slug as string;

  const props = await getSitemapData({
    slug,
  });

  return {
    props,
  };
};

export const getServerSideProps = withEnhancedPageHandler(
  getServerSidePropsHandler
);

export default SitemapBySlug;
